import IconButton from "@pathwright/ui/src/components/button/IconButton"
import SubmitButton from "@pathwright/ui/src/components/button/SubmitButton"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import { useScreensizeContext } from "@pathwright/ui/src/components/ui/Screensize"
import { ConnectStores } from "lib/core/store"
import { useRef, useState } from "react"
import "./MemberListSearch.css"

const MemberListSearch = ({ query, loading, onChange, onSearch, onClear }) => {
  const [searchedText, setSearchedText] = useState("")
  const inputRef = useRef(null)
  const screensize = useScreensizeContext()

  const search = () => {
    setSearchedText(query)
    onSearch()
  }

  return (
    <div className="MemberListSearch">
      <label htmlFor="MemberListSearch">
        <IconButton
          onClick={() => (query ? onClear() : inputRef.current.focus())}
          icon={query ? "x" : "search"}
          color="#888"
          size={30}
        />
        <input
          className="MemberListSearch__input"
          placeholder={
            screensize == "sm" ? "Search..." : "Search by name or email..."
          }
          id="MemberListSearch"
          type="text"
          value={query}
          ref={inputRef}
          onChange={(e) => onChange(e.target.value)}
          onKeyDown={(e) => e.keyCode == 13 && search()}
        />
      </label>
      {(searchedText != query || loading) && (
        <SubmitButton
          className="MemberListSearch__submit"
          styleType="blank"
          submitting={loading}
          onClick={(e) => search()}
          rounded={false}
          size="large"
        >
          Go <Pathicon icon="arrow-right" />
        </SubmitButton>
      )}
    </div>
  )
}

MemberListSearch.displayName = "MemberListSearch"

const mapStateToProps = (state, ownProps) => {
  const { members_query: query, members_query_loading: loading } =
    state.memberStore.state
  const {
    searchMembers: onSearch,
    clearMembersQuery: onClear,
    changeMembersQuery: onChange
  } = state.memberStore.action

  return _.assign(
    {},
    {
      query,
      loading,
      onChange,
      onSearch,
      onClear
    },
    ownProps
  )
}

const stores = [
  { store: "member", watch: ["members_query", "members_query_loading"] }
]

export default ConnectStores(MemberListSearch, stores, {}, mapStateToProps)
